import { useLottie } from "lottie-react";
import loadingDotsAnimation from "../../assets/lottie/loading-dots.json";

export const DeLoading = () => {
  const options = {
    animationData: loadingDotsAnimation,
    loop: true,
    autoplay: true,
  };
  const { View } = useLottie(options);
  return View;
};

export const MiniDeLoading = () => {
  const options = {
    animationData: loadingDotsAnimation,
    loop: true,
    autoplay: true,
    style: { width: '175px', height: '175px', margin:'auto', maxHeight: "100%", maxWidth: "100%" }
  };
  const { View } = useLottie(options);
  return View;
};
